import type { FacetConfiguration } from "../facet/type.ts";

export type FilterTitleMode =
  | "onlyTitle"
  | "full"
  | "onlyPopularValuesAndTitle"
  | "valuesAndTitle"
  | "popularValuesExclusion";

export type FilterMode = "default" | "sheetFirstLevel" | "sheetSecondLevel";

export type FilterConfiguration = {
  facetConfig: FacetConfiguration;
};

export type FilterModeConfigurations = {
  default: FilterConfiguration;
  sheetFirstLevel?: FilterConfiguration;
  sheetSecondLevel?: FilterConfiguration;
};

export type ConfigurableFilterOptions = {
  filterConfig: FilterModeConfigurations;
};

export function switchFilterMode(config: FilterModeConfigurations, mode: FilterMode): FilterConfiguration {
  if (!config[mode]) {
    return config.default;
  }
  return config[mode];
}
